define('constants/messagingTextsPerDayEnumerations',[], function() {
    return {
        ZeroToFiveHundred: 1,
        FiveHundredAndOneToOneThousand: 2,
        OneThousandAndOneToTwoThousand: 3,
        MoreThanTwoThousand: 4
    };
});
